<template>
  <div class="tab-pane active" id="form-step-1">
    <div class="row" >
      <div class="col-sm-12">
        <h4 class="info-text ">
          Let's start with some basic information
        </h4>
      </div>
      <div class="col-sm-6" >
        <div class="form-group">
          <label class="form-label required">Title</label>
          <select
            name="title"
            class="form-control custom-select"
            required
            v-model="title"
            :class="{ error: errors.has('step1.title') }"
            data-vv-scope="step1"
            v-validate="'required'"
          >
            <option value="">Select...</option>
            <option value="46">Mr.</option>
            <option value="47">Mrs.</option>
            <option value="51">Ms</option>
            <option value="253">Miss.</option>
            <option value="48">Dr.</option>
            <option value="49">Sir</option>
            <option value="122">Professor</option>
            <option value="441">Lady</option>
            <option value="50">Lord</option>
            <option value="506">Other</option>
          </select>
        </div>
      </div>
      <div class="col-sm-12 ">
        <div class="form-group">
          <label class="form-label required">First Name</label>&nbsp;<label class="small">(as appears on Passport or Driving licence)</label>
          <input
            name="firstname"
            type="text"
            class="form-control"
            placeholder="First Name"
            v-model.trim="firstName"
            :class="{ error: errors.has('step1.firstname') }"
            data-vv-scope="step1"
            v-validate="'required'"
          />
          <!-- <label class="error" v-show="errors.has('step1.firstname')">This field is required.</label> -->
        </div>
      </div>
      <div class="col-sm-12 ">
        <div class="form-group">
          <label class="form-label required">Last Name</label>
          <input
            name="lastname"
            type="text"
            class="form-control"
            :class="{ error: errors.has('step1.lastname') }"
            placeholder="Last Name"
            v-model.trim="lastName"
            data-vv-scope="step1"
            v-validate="'required'"
          />
        </div>
      </div>
      <div class="col-sm-12" v-if="!isExistingClient">
        <div class="form-group">
          <label class="form-label required">Email</label>
          <input
            name="email"
            type="email"
            class="form-control"
            :class="{ error: errors.has('step1.email') }"
            placeholder="Email Address"
            v-model.trim="email"
            data-vv-scope="step1"
            v-validate="'required|email'"
          />
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label class="form-label required">Mobile</label>
          <div class="row">
            <div class="col-sm-4">
              <vue-select
                class="vue-select"
                name="mobilePrefix"
                placeholder="Prefix"
                :options="countryCodes"
                :reduce="
                  (code) => code.TwoCharCode + '|' + code.CountryTelCode + '|'
                "
                :class="{ error: errors.has('step1.mobilePrefix') }"
                label="CountryTelCode"
                v-model="mobilePrefix"
                data-vv-scope="step1"
                v-validate="'required'"
                autocomplete="none"
              >
                <template slot="selected-option" slot-scope="option">
                  <div class="flex">
                    <div class="long-and-truncated-with-child-corrected">
                      <span>{{ option.CountryTelCode }}</span>
                    </div>
                  </div>
                </template>
                <template slot="option" slot-scope="option">
                  <span
                    class="flag-icon flag-icon-squared"
                    :class="('flag-icon-' + option.TwoCharCode) | lowerCase"
                  ></span
                  >&nbsp;
                  {{ option.CountryTelCode }}
                </template>
              </vue-select>
            </div>
            <div class="col-sm-8 mt-xs-10">
              <input
                type="tel"
                name="mobile"
                class="form-control"
                placeholder="Mobile"
                required
                v-model.trim="mobile"
                :class="{ error: errors.has('step1.mobile') }"
                data-vv-scope="step1"
                v-validate="'required'"
              />
            </div>
          </div>
        </div>
      </div>
       
    </div>
   
  </div>
</template>
<script>

import { mapFields } from 'vuex-map-fields';
import {mapGetters} from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "flag-icon-css/css/flag-icon.min.css";
export default {
  name: "About",
  components:{
    "vue-select": VueSelect
  },
  computed:{
     ...mapFields([
      'form.title',
      'form.firstName',
      'form.lastName',
      'form.email',
      "form.mobilePrefix",
      "form.mobile",
    ]),
     ...mapGetters({
      formData: "getFormData",
      countryCodes: "getCountryCodes",
       showAntiSpam:"getAntiSpam",
    }),
    isExistingClient(){
      return (this.email != "" && this.formData.isContactExist);
    }
  },
  data() {
    return {
      error: null
    };
  },
  async created(){
    if (this.$route.params.cleanForm )
    {
      //clear form
      this.title="";
      this.firstName="";
      this.lastName="";
      this.email="";
      this.$route.params.cleanForm=null;
    }
   
  }
};
</script>
